import ExclamationMark from "../../../img/icons/exclaimation-mark.svg?react";
import { ElementNewsLink } from "../../links/ElementNewsLink";
import { alertIcon, elementNewsAlertStyles } from "../alerts.css";
import { contentRow, newsLink, newsText } from "./elementNewsAlert.css";
import { ElementNewsAlertProps } from "./types";

const ElementNewsAlert = ({
  copnr,
  news,
  newsUrl,
  onNewsLinkPress,
}: ElementNewsAlertProps) =>
  copnr !== null && (
    <div className={elementNewsAlertStyles[copnr]}>
      <ExclamationMark className={alertIcon} />
      <div className={contentRow}>
        <div className={newsText}>{news}</div>
        {newsUrl && (
          <div className={newsLink}>
            <ElementNewsLink href={newsUrl} onPress={onNewsLinkPress} />
          </div>
        )}
      </div>
    </div>
  );
export default ElementNewsAlert;
